import state from '~store/modules/invoices/state'
import actions from '~store/modules/invoices/actions'

export default {
  state,
  actions
}
